export enum InvestorInvestmentUploadStatus {
  Pending = 'Pending',
  Processing = 'Processing',
  Completed = 'Completed',
}

export enum IdentifyUploadInvestorMatchStatus {
  New = 'New',
  Existing = 'Existing',
  Ambiguous = 'Ambiguous',
  Invalid = 'Invalid',
}

export enum UploadIssueCode {
  EmailDobMismatch = 'EmailDobMismatch',
  PrimaryTaxIdMissing = 'PrimaryTaxIdMissing',
  TaxResidencyMissing = 'TaxResidencyMissing',
  LeuTaxResidencyMissing = 'LeuTaxResidencyMissing',
  PaymentDateMissing = 'PaymentDateMissing',
  PaidToMissing = 'PaidToMissing',
  FuturePaymentDate = 'FuturePaymentDate',
  AdviserMismatch = 'AdviserMismatch',
  InvestorTrancheFirmMismatch = 'InvestorTrancheFirmMismatch',
  DuplicateExternalInvestmentId = 'DuplicateExternalInvestmentId',
  CashBalanceOutOfRange = 'CashBalanceOutOfRange',
  MissingRequiredField = 'MissingRequiredField',
  InvalidFieldValue = 'InvalidFieldValue',
  AmbiguousMatch = 'AmbiguousMatch',
  MissingEmailForNewInvestor = 'MissingEmailForNewInvestor',
  PossibleExistingInvestorByEmail = 'PossibleExistingInvestorByEmail',
  MissingIdentityFields = 'MissingIdentityFields',
  TaxResidencyMismatch = 'TaxResidencyMismatch',
  TrancheBankDetailsMissing = 'TrancheBankDetailsMissing',
}

export enum UploadIssueSeverity {
  Error = 'Error',
  Warning = 'Warning',
}

export type UploadIssue = {
  rowId: number;
  columnId: string;
  code: UploadIssueCode;
  message: string;
  rowFullName: string;
  severity: UploadIssueSeverity;
};

export const DateColumnLabels = {
  identity_date: 'Birth/registration date',
  investment_date: 'Investment date',
  payment_date: 'Payment date',
};

export type UploadDateFieldKey =
  | 'identity_date'
  | 'investment_date'
  | 'payment_date';
